const axios = window.axios || require('axios');

window.TVA_AUTH = window.TVA_AUTH || {};

window.TVA_AUTH.RegistrationStatusPage = function(options) {
    const statusUrl = options.statusUrl;

    const checkStatus = function() {
        axios.get(statusUrl)
            .then(response => {
                if (response.data.status === 'pending') {
                    setTimeout(checkStatus, 5000);
                } else {
                    // registration complete or error -> reload page and let backend handle the next steps
                    window.location.reload();
                }
            })
            .catch(error => {
                console.error(error);
                window.location.reload();
            });
    }

    const init = function() {
        setTimeout(checkStatus, 3000);

        // fallback to reload page after 1 minute in case of error
        setTimeout(() => {
            window.location.reload();
        }, 60000);
    }


    return {
        init: init
    };
};
